<template>
  <div style="display: inline-block;">
    <template v-if="!see">
      <el-select @clear="clear" v-bind="$attrs" :disabled="disabled" v-on="$listeners" filterable :value="value"
        :clearable="clearable" @change="select" @visible-change="blur" :multiple="isMultiple">
        <el-option v-for="(item, index) in options" :dataOption="dataOption" :key="index" :dataLabel="labels"
          :dataValues="values" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
      </el-select>
    </template>
    <template v-else>
      <div class="el-form-detail">{{ seeLabel }}</div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    see: {
      type: Boolean,
      default: false
    },
    dataOption: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number, Boolean, Array],
      default: () => { }
    },
    type: {
      type: String,
      default: ""
    },
    includeAll: {
      type: Boolean,
      default: true
    },
    values: {
      type: String,
      default: "value"
    },
    labels: {
      type: String,
      default: "label"
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    clear: function () {
      this.$emit("clear");
    },
    select: function (e) {
      this.$emit("select", e);
    },
    blur(e) {
      this.$emit("blur", e);
    }
  },
  computed: {
    options() {
      let arr = new Array();
      if (this.dataOption) {
        let filteredData = this.dataOption.filter(item => item.status !== 0);
        arr = filteredData.map(item => {
          console.log(item)
          return {
            label: item[this.labels],
            value: item[this.values],
            disabled: item.disabled || false
          };
        });
      }
      return arr;
    },
    seeLabel() {
      if (this.options.length && this.value.toString()) {
        console.log(4);
        console.log(
          this.options.find(v => {
            return v.value === this.value;
          }).label
        );
        return this.options.find(v => {
          return v.value === this.value;
        }).label;
      }
      return "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/selectTmpl/index.vue